document.addEventListener("DOMContentLoaded", () => {
  const observer = new MutationObserver(() => {
    const app = document.querySelector("#app-embed");
    if (!app || !app.shadowRoot) return;

    observer.disconnect();
    const shadow = app.shadowRoot;

    const form = shadow.querySelector('form[data-testid="form"]');
    const submitBtn = shadow.querySelector('button[type="submit"]');
    if (!form || !submitBtn) return;

    const sheet = new CSSStyleSheet();

    sheet.insertRule(`
      ._inline_1q1d2_47 ._formContainer_1q1d2_30 {
        margin: 0 !important;
        margin-top: 32px !important;
        max-width: 100% !important;
        border-top: 1px solid #3E272333 !important;
      }
    `);

    sheet.insertRule(`
      @media screen and (max-width: 990px) {
       #form-container-ref ._inline_1q1d2_47 ._formContainer_1q1d2_30 {
          margin-top: 24px !important;
          margin-bottom: 36px !important;
        } 
      }
    `);

    sheet.insertRule(`
      ._inline_1q1d2_47 ._formHeader_cit2d_24 {
        margin: 0;
      }
    `);

    sheet.insertRule(`
      ._inline_1q1d2_47 ._formHeader_cit2d_24 ._textHeading_2aowh_35 {
        margin: 0;
        margin-bottom: 20px;  
        color: #3E272399;
        font-family: "CabinetGrotesk";
        font-weight: 500;
        font-size: 16px;
        line-height: 176%;
        letter-spacing: -1%;
      }
    `);

    sheet.insertRule(`
      ._inline_1q1d2_47 ._formHeader_cit2d_24 ._textBody_2aowh_10 p {
        margin: 0;
        margin-bottom: 32px;
        color: var(--color-brand-palette-dark-brown, #3E2723);
        text-align: center;
        font-family: "CabinetGrotesk";
        font-size: 36px;
        font-style: normal;
        font-weight: 300;
        line-height: 124%;
        letter-spacing: -0.54px;
      }
    `);

    sheet.insertRule(`
      ._inline_1q1d2_47 ._formFieldset_cit2d_82 {
        display: flex !important;
        flex-flow: row wrap !important;
        row-gap: 8px !important;
        column-gap: 16px !important;
      }
    `);

    sheet.insertRule(`
      @media screen and (max-width: 990px) {
       ._container_3eyaa_70._fadeAnimation_3eyaa_87 {
          display: flex !important;
        } 
      }
    `);

    sheet.insertRule(`
      @media screen and (max-width: 990px) {
       #form-container-ref {
          width: 100% !important;
        } 
      }
    `);

    sheet.insertRule(`
      input._formInputField_nag3b_7 {
        background: transparent;  
      } 
    `);

    sheet.insertRule(`
      ._formFieldContainer_1mxsl_5 {
        width: 100% !important;
        margin: 0 !important;
        box-sizing: border-box !important;
      }
    `);

    sheet.insertRule(`
      ._formFieldContainer_1mxsl_5:has([id="custom#budget"]),
      ._formFieldContainer_1mxsl_5:has([id="custom#timeline"]) {
        width: calc(50% - 8px) !important;
      }
    `);

    // These fields are auto-filled in the background from the product's own
    // selectors (see product-inquiry-form-sync.js) and should stay out of view.
    sheet.insertRule(`
      ._formFieldContainer_1mxsl_5:has([data-testid="field-custom#metal_option"]),
      ._formFieldContainer_1mxsl_5:has([data-testid="field-custom#eu_ring_size"]),
      ._formFieldContainer_1mxsl_5:has([data-testid="field-custom#diamond_option"]),
      ._formFieldContainer_1mxsl_5:has([data-testid="field-custom#diamond_type"]) {
        display: none !important;
      }
    `);

    sheet.insertRule(`
      ._inline_1q1d2_47 ._formFieldset_cit2d_82 input._formInputField_nag3b_7 {
        padding: 0 var(--form-field-padding, 15px);
        background: transparent;
        border: 1px solid #3E272333;
        border-radius: 4px;
        box-shadow: none;
        height: 48px;
        box-sizing: border-box;
      }
    `);

    sheet.insertRule(`
      ._formFieldContainer_1mxsl_5 textarea {
        padding: 20px var(--form-field-padding, 15px);
        background: transparent;
        border: 1px solid #3E272333;
        border-radius: 4px;
        box-shadow: none;
        box-sizing: border-box;
        height: 180px;
      }
    `);

    sheet.insertRule(`
      ._formFieldContainer_1mxsl_5:has(textarea)::before {
        display: none !important;
      }
    `);

    sheet.insertRule(`
      ._formFieldContainer_1mxsl_5 ._formInputFieldLabel_1mxsl_38 {
        color: var(--color-brand-dark-opacity-500, rgba(62, 39, 35, 0.50));
        font-family: "CabinetGrotesk";
        font-size: 14px;
        font-weight: 400;
        line-height: 94%;
        letter-spacing: 0.14px;
      }
    `);

    sheet.insertRule(`
      ._formFieldContainer_1mxsl_5:focus-within ._formInputFieldLabel_1mxsl_38 {
        top: 10.5px !important;
      }
    `);

    sheet.insertRule(`
      ._formFieldContainer_1mxsl_5 ._inputFilled_1mxsl_74 {
        top: 10.5px !important;
      }
    `);

    sheet.insertRule(`
      ._formFileInput_ehvsf_1 ._textBody_2aowh_10 {
        display: none !important;
      }
    `);

    sheet.insertRule(`
      ._formFileInput_ehvsf_1 {
        margin: 0 !important;
        padding: 0 !important;
        width: auto !important;
        display: inline-block !important;
      }
    `);

    sheet.insertRule(`
      ._formFileInput_ehvsf_1 button._formFileInputField_ehvsf_5 {
        margin-top: 16px !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 10px !important;
        background-color: transparent !important;
        border: 1px solid #3E2723 !important; 
        color: #3E2723 !important;             
        border-radius: 4px !important;         
        padding: 10px 24px !important;         
        cursor: pointer !important;
        width: auto !important;
        height: 40px !important;
        box-shadow: none !important;
        transition: all 0.2s ease !important;
      }
    `);

    sheet.insertRule(`
      ._formFileInput_ehvsf_1 button._formFileInputField_ehvsf_5 p {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        margin: 0 !important;
        font-family: "CabinetGrotesk", sans-serif !important;
        font-weight: 400 !important;
        font-size: 14px !important;
        color: inherit !important;
        margin-top: 0;
        padding: 0;
        background: transparent;
      }
    `);

    sheet.insertRule(`
      ._inline_1q1d2_47 ._formFieldset_cit2d_82 ._formSubmitButton_cit2d_96 {
        margin-top: 20px;  
        width: 100%;  
        cursor: pointer;
        height: 4.4rem;
        padding: 1.75rem 2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 1rem;
        font-family: CabinetGrotesk, sans-serif;
        font-size: 1.4rem;
        font-weight: 400;
        color: #fffcf8;
        background-color: #3e2723;
        border-radius: .2rem;
        text-decoration: none;
        border: none;
        transition: .3s ease-in-out;
        box-sizing: border-box !important;
      }
    `);

    sheet.insertRule(`
      h2._textHeading_2aowh_35 {
        font-family: "CabinetGrotesk";
      }
    `);

    sheet.insertRule(`
      button._formSubmitButton_jnbzb_106 {
        font-family: "CabinetGrotesk";
      }
    `);

    shadow.adoptedStyleSheets = [...shadow.adoptedStyleSheets, sheet];

    const uploadTextElement = shadow.querySelector(
      "._formFileInputButton_ehvsf_18"
    );
    
    if (uploadTextElement) {
      uploadTextElement.innerHTML = `
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 10V10.8C14 11.9201 14 12.4802 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.4802 14 11.9201 14 10.8 14H5.2C4.07989 14 3.51984 14 3.09202 13.782C2.71569 13.5903 2.40973 13.2843 2.21799 12.908C2 12.4802 2 11.9201 2 10.8V10M11.3333 5.33333L8 2M8 2L4.66667 5.33333M8 2V10" stroke="#3E2723" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>Upload Image</span>
      `;

      uploadTextElement.style.display = "inline-flex";
      uploadTextElement.style.alignItems = "center";
      uploadTextElement.style.justifyContent = "center";
    }

  });

  observer.observe(document.body, { childList: true, subtree: true });
});